import { DataSet } from "../core/Workbook";
import { deepCopyDataset } from "./deepCopy";
import { sortIntAsc, sortIntDesc } from "../utils/sortComparators";
import { arrayToDict } from "../utils/dictionaryUtils";

export function getOrCreateOrder(dataset: DataSet) {
  return dataset.naturalOrder ?? arrayToDict(Object.keys(dataset.data), 0);
}

export function deleterFunction(
  selectedRows: number[]
): (arg: DataSet) => DataSet {
  return (dataset) => {
    const newDataset = deepCopyDataset(dataset);
    let order = getOrCreateOrder(newDataset);
    selectedRows.sort(sortIntDesc);
    selectedRows.forEach((selectedRowId) => {
      // Delete rows
      if (selectedRowId in order) {
        const selectedObjectKey = order[selectedRowId];
        if (selectedObjectKey in newDataset.data) {
          delete newDataset.data[selectedObjectKey];
        }
        delete order[selectedRowId];
      }
      // And move up remaining rows
      // Do this is a slightly backwards way to deal with sparse nature of array
      const rowIdxs = Object.keys(order);
      rowIdxs.sort(sortIntAsc);
      rowIdxs.forEach((rowIdxKey) => {
        const rowIdx = parseInt(rowIdxKey);
        if (rowIdx > selectedRowId) {
          if (rowIdx in order) {
            order[rowIdx - 1] = order[rowIdx];
          } else {
            delete order[rowIdx - 1];
          }
          delete order[rowIdx];
        }
      });
    });
    newDataset.naturalOrder = order;
    return newDataset;
  };
}

export function inserterFunction(
  selectedRows: number[]
): (arg: DataSet) => DataSet {
  return (dataset) => {
    const newDataset = deepCopyDataset(dataset);
    let order = getOrCreateOrder(newDataset);
    const selectedRowsTemp = [...selectedRows];
    selectedRowsTemp.sort();
    selectedRowsTemp.forEach((selectedRow) => {
      const rowIdxs = Object.keys(order);
      rowIdxs.sort(sortIntDesc);
      rowIdxs.forEach((rowIdxKey) => {
        const rowIdx = parseInt(rowIdxKey);
        if (rowIdx >= selectedRow) {
          if (rowIdx in order) {
            order[rowIdx + 1] = order[rowIdx];
          } else {
            delete order[rowIdx + 1];
          }
          delete order[rowIdx];
        }
      });
    });
    newDataset.naturalOrder = order;
    return newDataset;
  };
}
